import Model from "../../../Model.js";
import Section from "./ChecklistSection.js";

/**
 * Represent a list of todo items for accountants to check when
 * editing a period report. The receiver is instanciated from a
 * corresponding ChecklistTemplate.
 *
 * The todo items are organized in named sections (e.g., "Business
 * overview" or "Income Statement").
 *
 * @param {ChecklistSection[]} sections - sections
 * containing items and related to a period report's own sections.
 */
export default class Checklist extends Model {
	constructor({ sections = [] } = {}) {
		super(...arguments);

		this._sections = sections;
	}

	getSections() {
		return this._sections;
	}

	sectionFromId(sectionId) {
		return this._sections.find((section) => section.getId() === sectionId);
	}

	getItems() {
		return this._sections.reduce(
			(items, section) => [...items, ...section.getItems()],
			[],
		);
	}

	isCompleted() {
		return this.getItems().every((item) => item.isChecked());
	}

	firstUncheckedItem() {
		return this.getItems().find((item) => !item.isChecked());
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.sections = Section.materializeAll(data.sections, context);
	}
}
